@for (child of node?.children; track child) {
  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }">
  </ng-container>
}
<!-- we generate links in a recursive manner -->
<ng-template #nav let-node="node" let-depth="depth">
  @if (isMenu) {
    @if (node.hasEntries) {
      <nav class="{{node.name}}" (click)="toggleOpen($event)" (mouseenter)="onMouseEnter($event)"
        (keydown.space)="toggleOpen($event)" (keydown.esc)="back()">
        @if (
          node.url && !!node.title && (!node.children || node.children?.length === 0)) {
          <cx-generic-link [isMenu]="true" [url]="node.url" [target]="node.target" [style]="node.styleAttributes" [class]="node.styleClasses"
            [icon]="node.icon">
            {{ node.title }}
          </cx-generic-link>
        } @else {
          @if (!!node.title) {
            <div class="h5-header" [class]="node.styleClasses" [attr.aria-label]="node.title"
              [attr.tabindex]="(depth === 0 || node.url) ? 0 : -1" (click)="goToElement(node.styleClasses)">
              {{ node.title }}
              @if (node.children?.length > 0) {
                <app-custom-icons [type]="iconType.PLUS"></app-custom-icons>
              }
              @if (node.children?.length > 0) {
                <app-custom-icons [type]="iconType.MINUS"></app-custom-icons>
              }
            </div>
          }
        }
        @if (node.children?.length > 0) {
          <div class="wrapper">
            <div class="childs" [attr.depth]="getTotalDepth(node)"
              [attr.wrap-after]="node.children?.length > wrapAfter ? wrapAfter : null"
              [attr.columns]="getColumnCount(node.children?.length)">
              @for (child of node.children; track child) {
                @if (isLogged | async; as logged) {
                  @if (logged && child.name != 'ProfesionalLink' && child.name != 'LoggInLink' && child.title != 'Accede') {
                    <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }">
                    </ng-container>
                  }
                } @else {
                  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }">
                  </ng-container>
                }
              }
            </div>
          </div>
        }
      </nav>
    }
  } @else {
    <nav class="{{node.name}}" (click)="toggleOpen($event)" (mouseenter)="onMouseEnter($event)"
      (keydown.space)="toggleOpen($event)" (keydown.esc)="back()">
      @if (
        !!node.url && !!node.title && (!node.children || node.children?.length === 0)) {
        <cx-generic-link [url]="node.url" [target]="node.target" [style]="node.styleAttributes" [class]="node.styleClasses"
          [icon]="node.icon" (click)="goToElement(node.name)">
          {{ node.title }}
        </cx-generic-link>
      } @else {
        @if (!!node.title) {
          <div class="h5-header" [class]="node.styleClasses" [attr.aria-label]="node.title"
            [attr.tabindex]="(depth === 0 || node.url) ? 0 : -1">
            {{ node.title }}
            @if (node.children?.length > 0) {
              <app-custom-icons [type]="iconType.PLUS"></app-custom-icons>
            }
            <app-custom-icons [type]="iconType.MINUS"></app-custom-icons>
          </div>
        }
      }
      @if (node.children?.length > 0) {
        <div class="wrapper">
          <div class="childs" [attr.depth]="getTotalDepth(node)"
            [attr.wrap-after]="node.children?.length > wrapAfter ? wrapAfter : null"
            [attr.columns]="getColumnCount(node.children?.length)">
            @for (child of node.children; track child) {
              @if (isLogged | async; as logged) {
                @if (logged && child.name != 'ProfesionalLink' && child.name != 'LoggInLink' && child.title != 'Accede') {
                  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }">
                  </ng-container>
                }
              } @else {
                <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }">
                </ng-container>
              }
            }
          </div>
        </div>
      }
    </nav>
  }
</ng-template>
